/* eslint-disable radix */

const DURATION_INCREMENTER = 5;

const DurationUtils = {
  formatDuration(duration) {
    const rest = duration % 60;
    const hours = Number.parseInt(duration / 60);
    let name = '';

    if (duration === 0) {
      return '0 min';
    }
    if (hours > 0) {
      name += `${hours} h`;
    }
    if (rest > 0) {
      name += ` ${rest} min`;
    }

    return name;
  },

  getDurationList(maxDuration = 480, durationIncrement = 0) {
    const durations = [];

    let duration = durationIncrement;
    while (duration <= maxDuration) {
      durations.push({
        name: DurationUtils.formatDuration(duration),
        id: duration,
      });
      duration += DURATION_INCREMENTER;
    }

    durations.push({
      name: '8 h 30 min',
      id: 510,
    });
    durations.push({
      name: '9 h',
      id: 540,
    });
    durations.push({
      name: '10 h',
      id: 10 * 60,
    });
    durations.push({
      name: '11 h',
      id: 11 * 60,
    });
    durations.push({
      name: '12 h',
      id: 12 * 60,
    });
    return durations;
  },
};

export { DurationUtils as default };
